import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Marginer } from "../../Components/Marginer";
import Logo from "../../Assets/Hnet.com-image.png";
import Backpanel from "../../Assets/Background.gif";
import Flowers from "../../Assets/books.jpg";
import {Facebook,Instagram,Twitter,Telegram,Linkedin} from "@styled-icons/boxicons-logos";
import {Link} from "react-scroll";
import { BlogComp } from "../../Components/Blog";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {Hourglass} from "react-loader-spinner"

const PageHolder = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const HeaderDiv = styled.div`
    width: 100%;
    height: 21vh;
    display: flex;
    flex-direction: column;
    background-color: #443C54;
    align-items: center;

    @media (max-width: 900px) {
        justify-content:center;
    }
`;

const Logoimg = styled.img`
    width: 190px;
    height: auto;
    margin-top: 1.8vw;

    @media (max-width: 900px) {
        margin-top: 5px;
    }

    &:hover{
        cursor:pointer;
    }

`;


const BottomLine = styled.div`
    width: 70vw;
    height: 1px;
    margin-top: 0.9vw;
    background-color: #ffffff6a;
    border-radius: 80%;
    box-shadow: 0px 2px 7px 2px #353535;

    @media (max-width: 900px) {
        width: 90vw;
        margin-top: 3vw;
    }

`;

const Linkholder = styled.div`
    width: 60vw;
    height: 3vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    @media (max-width: 900px) {
        width: 90vw;
    }

    @media (min-width: 900px) and (max-width: 1400px) {
        width: 70vw;
    }

`;


const SocialHolder = styled.div`
    width: 20vw;
    height: 3vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;



    @media (max-width: 600px) {
       
       width: 0vw;
       display: none;
    }

    @media (min-width: 600px) and (max-width: 900px) {
        
        width: 22vw;
    }

   

`;

const Facebooklink = styled(Facebook)`
  width: 1.2vw;
  color:${props => props.color};


  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }

`;

const Instagramlink = styled(Instagram)`
  width: 1.2vw;
  color:${props => props.color};


  &:hover{
        cursor: pointer;
        color: #e2d186;
    }
    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }
  
`;

const Twitterlink = styled(Twitter)`
  width: 1.2vw;
  color:${props => props.color};
  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }

`;

const Telegramlink = styled(Telegram)`
  width: 1.2vw;
  color:${props => props.color};


  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }

`;

const Linkedinlink = styled(Linkedin)`
  width: 1.2vw;
  color: ${props => props.color};

  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
        width: 3vw;
   }

   @media (min-width: 450px) and (max-width: 900px) {
       
        width: 2vw;
   }

   @media (min-width: 900px) and (max-width: 1300px) {
       
        width: 1.7vw;
   }

   @media (min-width: 1300px) and (max-width: 1700px) {
       
    width: 1.2vw;
   }

    

`;

const Numbertext = styled.h3`
    font-size: 0.8vw;
    color: white;
    font-weight: normal;
    margin-top: 9px ;

    @media (max-width: 600px) {
       
        font-size: 1.8vw;
    }

    @media (min-width: 600px) and (max-width: 900px) {
        
        font-size: 1.6vw;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        
        font-size: 1.2vw;
    }

    @media (min-width: 1300px) and (max-width: 1700px) {
        
        font-size: 0.9vw;
    }

  
  
`;

const LinkButton = styled.button`
    width:7vw;
    height:1.5vw;
    background-color: #443C54 ;
    border:0px;
    color: white;
    font-size: 1.1vw;

    &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 600px) {
        width: 35vw;
        font-size: 3.4vw;
        font-weight: bold;
    }

    @media (min-width: 600px) and (max-width: 900px) {
        width: 16vw;
        font-size: 2.4vw;
        font-weight: bold;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        width: 10vw;
        font-size: 1.7vw;
    }

    @media (min-width: 1300px) and (max-width: 1700px) {
        width: 9vw;
        font-size: 1.2vw;
    }

  
`;


const Mainpanel = styled.div`
  
  width:100%;
  height: 82vh;
  background-image: url(${Flowers});
  display: flex;
  flex-direction: column;
  object-fit: cover;
  background-position: bottom -950px left -1100px;
`;

const MainpanelCover = styled.div`
  width: 100%;
  height: 100%;
  background-color: #00000061;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  
`;

const BlogArea = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items:center;
  overflow-x: hidden;
`;


const BlogText = styled.p`
 font-size: 2vw;
 font-weight: bold;
 color: #ffffff;
 margin: 20px;

 @media (max-width: 600px) {
  font-size: 3.5vw;
  }

  @media (min-width: 600px) and (max-width: 900px) {
    font-size: 3vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
    font-size: 2.75vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
    font-size: 2.5vw;
  }

`;


const BlogList = styled.div`
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  align-items:center;
  overflow-y: scroll;
 
  margin:0;
  padding-right: 50px;
  margin-right: -50px;
`;



const LoginHolder = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column ;
  align-items: center;
  justify-content: center ;
`;

const Logindiv = styled.div`
  width: 40vw;
  min-height: 40vh;
  display: flex;
  flex-direction: column ;
  align-items: center;
  justify-content: center ;
  background-color: #f1f0f0;
  border-radius: 2%;
  border: solid 3px black;
`;

const LoginField = styled.h1` 
  font-size: 1.7vw;
  color:white;
  text-align: right;
  color: #443C54;
  margin-bottom: 40px;
`;

const LoginText = styled.h1` 
  font-size: 1.2vw;
  color:white;
  text-align: right;
  color: #443C54;
`;

const LoginInput = styled.input`
width: 80%;
height: 3vh;
font-size: 1.0vw;
unicode-bidi: plaintext;
border: solid 3px #000000;
padding: 10px;
margin-bottom: 20px;
`;

const ErrorFeild = styled.p` 
  font-size: 1vw;
  color: #f52020;
  text-align: right;
`;

const SubmitButton = styled.button`
border-radius: 5cm;
border: solid 5px white;
background-color: #211931;
color: #ffffff;
font-size: 1.4vw;
font-weight: bold;
padding: 20px;
margin-bottom: 40px;
min-width: 10vw;
&:hover{
  background-color: #c0c0c0;
  cursor: pointer;
}
&:active{
  background-color: white;
}
`;

const BottomNavigator = styled.div`
    display: flex;
    flex-direction: row;
`

const PageButton = styled.button`
    background-color: #443C54;
    font-size: 1.2vw;
    color:white;
    border: none;
    padding:10px;
    margin:0.5vw;
    &:hover{
        cursor: pointer;
        color: #e2d186;
    }
`;


export function BlogEditor(props){

    const [blogs, setBlogs] = useState([])
    const [page, setPage] = useState(0)
    const [lastpage, setLastpage] = useState(false)
    const [loading, setLoading] = useState(true)
    const [pswderror, setPswderror] = useState(false);
    const [password, setPassword] = useState("");
    const [login,setLogin] = useState(window.localStorage.getItem('login'));
    const navigate = useNavigate();

    function next_page(){
      setPage(page+1)
      setBlogs([])
  }

  function previous_page(){
      setPage(page-1)
      setBlogs([])
  }


    useEffect(() => {
        setLoading(true)
        axios.post('https://salwa-amer-backend.onrender.com/get_blogs',
          { "page": page},
          { headers: { 'Content-Type': 'application/json' } })
      .then(res => {
          const blogslist = res.data;
            setBlogs( blogslist );

            if(blogslist.length === 0){
              setLastpage(true)
            }else{
                setLastpage(false)
            }

            setLoading(false)
        })
        
    },[page])

    function checkpassword(){
        if(password == "damnhour"){
          setLogin(true);
          window.localStorage.setItem('login',true)
        }else{
          setPswderror(true);
        }
      }
    
    return(
        <>
        {login?<>
        <PageHolder>
           <HeaderDiv>
          <Logoimg onClick={()=>{navigate("/admin")}} src = {Logo} ></Logoimg>
          <BottomLine/>
          <Marginer height={2} width ={1}></Marginer>
          <Linkholder>
          <LinkButton onClick={()=>{navigate("/admin/blogs")}}> تعديل منشورات</LinkButton>
          <LinkButton onClick={()=>{navigate("/admin")}}> اضافة منشور </LinkButton>
          </Linkholder>
          </HeaderDiv>
            <Mainpanel>
                <MainpanelCover>
                    <BlogArea>
                        <BlogText>اخر المنشورات</BlogText>
                        <BlogList>
                            {blogs.length > 0?
                            <>
                                  {blogs.map(function(blog) {
                                    return (
                                        <BlogComp image = {blog.image} title={blog.title} content={blog.content} editable={true} id={blog._id} />
                                    )
                                  })}
                            </>: <>
                                    {loading === true?<Hourglass
                                                        visible={true}
                                                        height="80"
                                                        width="80"
                                                        ariaLabel="hourglass-loading"
                                                        wrapperStyle={{"margin":"25px"}}
                                                        wrapperClass=""
                                                        colors={['#ffffff', '#ffffff']}
                                                        />:
                                    <BlogText>لا توجد منشورات </BlogText>
                                    }
                            </>
                            }
                        </BlogList>
                        <BottomNavigator>
                        {lastpage == false? 
                        <PageButton onClick={next_page}>التالي</PageButton>
                        :<></>}
                        {page > 0? 
                        <PageButton onClick={previous_page}>السابق</PageButton>
                        : <></>
                        }
                        </BottomNavigator>
                    </BlogArea>
                </MainpanelCover>
            </Mainpanel>
            
        </PageHolder>
        </>:<>
        <Mainpanel>
            <MainpanelCover>

        <LoginHolder>
          <Logindiv>
            <LoginField>تسجيل الدخول</LoginField>
            <LoginText>الرجاء ادخال كلمة السر</LoginText>
            <LoginInput onChange={(e)=>{setPassword(e.target.value)}} type="password"></LoginInput>
            {pswderror?<><ErrorFeild>كلمة السر خطأ</ErrorFeild> </>:<></>}
            <SubmitButton onClick={checkpassword}>الدخول</SubmitButton>
          </Logindiv>
        </LoginHolder>

        </MainpanelCover>
        </Mainpanel>
        </>}
    </>
    );
}